import { useState } from 'react';
import { signIn } from '../firebase/auth';
import './Login.scss';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await signIn(email, password);
    } catch (err) {
      setError('Invalid email or password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-background">
        <div className="floating-hearts">
          {[...Array(12)].map((_, i) => (
            <div key={i} className="heart" style={{ left: `${(i * 8.5) % 100}%`, animationDelay: `${(i * 0.4) % 5}s` }}>
              ♥
            </div>
          ))}
        </div>
      </div>

      <div className="login-card">
        <div className="login-header">
          <div className="heart-icon">♥</div>
          <h1 className="couple-names">Rajesh Kanna & Indira</h1>
          <p className="wedding-date">May 29, 2026</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
              className={error ? 'input-error' : ''}
            />
          </div>

          <div className="form-group">
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              autoComplete="current-password"
              className={error ? 'input-error' : ''}
            />
          </div>

          {error && <p className="error-message">{error}</p>}

          <button type="submit" className="btn-login" disabled={loading}>
            {loading ? 'Signing in...' : 'Log In'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
